import { callGraphQlClient, getErrors, getUserErrors, resolveError } from '@/functions/loaderGraphQl'
import { createOrderRecipe } from '@/graphql/mutation/createOrderRecipe'
import { showError } from '@/functions/ui/toastify'
import { destroyOrderRecipe } from '@/graphql/mutation/destroyOrderRecipe'
import { AddonsCategoryTypeEnum } from '@/constants/constants'
import { captureException } from '@sentry/nextjs'

export function findIfRecipeInOrder(product, order) {
    if (order != null) {
        return order.order.items.filter(item => {
            return item.recipe.id === product.id
        }).length
    }
}

function setupSideDishes(sideDishes) {
    if (!sideDishes) return []
    const addonsMapped = sideDishes.map(item => {
        return {
            categoryId: item.wareCategoryId,
            recipeId: item.id
        }
    })
    console.log(addonsMapped)
    return addonsMapped
}

export function addProduct(
    orderId,
    productData,
    note,
    sideDishes,
    wareCategoryId,
    promoTag,
    successAction,
    errorAction,
    successResponse = false,
    router,
    dispatch
) {
    const variables = {
        orderId: parseInt(orderId),
        recipe: parseInt(productData.id),
        amount: 1,
        note: note ? note : '',
        sideDishes: setupSideDishes(sideDishes),
        wareCategoryId: wareCategoryId ? wareCategoryId : null,
        promoTag: promoTag ? promoTag : null
    }
    callGraphQlClient(createOrderRecipe, variables, dispatch)
        .then(() => {
            if (successAction) successAction(successResponse)
        })
        .catch(err => {
            let userErrors = getUserErrors(err.response)
            if (userErrors.length !== 0)
                userErrors.map(item => {
                    showError(item.message)
                })
            else {
                let errors = getErrors(err.response)
                resolveError(errors, router)
                const tooManyItems = errors.filter(item =>
                    item.includes('V košíku objednávky je příliš mnoho položek a další už nelze přidat!')
                )
                if (tooManyItems.length !== 0) {
                    showError(tooManyItems[0])
                }
            }
            if (errorAction) errorAction()
        })
}

export async function removeProduct(recipeId, router, errorAction, dispatch) {
    const variables = {
        id: parseInt(recipeId)
    }
    return await callGraphQlClient(destroyOrderRecipe, variables, dispatch).catch(err => {
        captureException(err)
        let errors = getErrors(err.response)
        resolveError(errors, router)
        errorAction()
    })
}

export function findItemInArray(objects, product) {
    if (objects) {
        const foundProduct = objects.filter(item => {
            return item.id === product.id
        }).length

        if (foundProduct === 0 || !foundProduct) return null
        else return foundProduct
    }
}

export const addSideDishToProduct = (addons, product, type, categoryId) => {
    console.log(product)
    const sideDish = {
        id: product.id,
        amount: 1,
        price: product.price.value,
        type: type,
        wareCategoryId: categoryId
    }
    addons.push(sideDish)

    return addons
}

export const checkAddonConstrains = (category, addons, productId) => {
    let validationMessage = ''
    if (category.type === AddonsCategoryTypeEnum.AMOUNT || category.type === AddonsCategoryTypeEnum.CHECKBOX) {
        let recipeInCategoryCount = 0
        category.recipes.map(recipe => {
            addons.map(addon => {
                if (addon.id === recipe.id) recipeInCategoryCount++
            })
        })

        let recipeCount = addons.filter(addon => productId === addon.id).length

        if (category.maxRecipesCount !== 0) {
            if (category.maxRecipesCount > 0 && recipeCount == category.maxRecipesCount) {
                validationMessage = `Každý recept lze přidat pouze ${category.maxRecipesCount}x`
                return {
                    error: true,
                    validationMessage: validationMessage
                }
            }
        }

        if (category.maxCount !== 0) {
            if (recipeInCategoryCount >= category.maxCount) {
                validationMessage = `Nelze přidat více než ${category.maxCount} přídavky`
                return {
                    error: true,
                    validationMessage: validationMessage
                }
            }
        }
    }
    return {
        error: false,
        validationMessage: ''
    }
}
export const checkOrderItemConstrains = (categories, addons) => {
    let validationMessage = []

    categories.map(category => {
        let countRecipes = 0
        category.recipes.map(recipe => {
            addons.map(addon => {
                if (addon.id === recipe.id) countRecipes++
            })
        })
        if (category.minCount !== 0 && category.minCount > countRecipes) {
            validationMessage.push(`'${category.nameLabel}' vyberte přídavky -  minimálně ${category.minCount}`)
        }
    })
    if (validationMessage.length !== 0)
        return {
            passed: false,
            validationMessage: validationMessage
        }
    else
        return {
            passed: true,
            validationMessage: validationMessage
        }
}

export const removeSideDishFromProduct = (addons, product) => {
    const indexOfObject = addons.findIndex(object => {
        return object.id === product.id
    })
    if (indexOfObject !== -1) addons.splice(indexOfObject, 1)
    else return null
    return addons
}

export const calculateItemPrice = (productData, addons) => {
    if (productData) {
        let totalPrice = 0
        totalPrice += productData.price.value
        addons.map(addon => {
            totalPrice += addon.price
        })
        totalPrice += ' ' + productData.price.currency.code
        return totalPrice
    }
}
